export function render(node, renderBranch) {
    return null;
}
